module.exports = __webpack_public_path__ + "img/join-code.bd93c72e.svg";